module.exports = __webpack_public_path__ + "static/media/AMXCondensed.61fc1f31.svg";